import { addDays, format } from 'date-fns';

export const mockTime = Array.from({ length: 8 }, (_, index) => {
  // Generate dates starting from today and for the next 7 days
  return format(addDays(new Date(), index), 'yyyy-MM-dd');
}).map(date => ({
  date,
  timeSlots: ['morning', 'afternoon', 'evening'].map(type => {
    const available = Math.random() > 0.1 ? 'true' : 'false'; // 90% chance available
    const bookMax = Math.floor(Math.random() * 40) + 10; // 10–49
    const bookedCount = available === 'true'
      ? Math.floor(Math.random() * (bookMax + 1)) // 0 to bookMax
      : 0;

    return {
      type,
      available,
      bookedCount,
      bookMax
    };
  })
}));
